// src/utils/downloadUtils.js
export const handleDownloadTraining = () => {
  const link = document.createElement('a');
  link.href = '/training-induction-template.xlsx'; // path in public folder
  link.setAttribute('download', 'training.xlsx');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const handleDownloadInduction = () => {
  const link = document.createElement('a');
  link.href = '/training-induction-template.xlsx'; // path in public folder
  link.setAttribute('download', 'induction.xlsx');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
